import BaseEntity from "@/core/misc/BaseEntity";

class EdiOperator extends BaseEntity {
    public name: string;

    static fromServer(data: any, result = new EdiOperator()): EdiOperator {
        return super.fromServer(data, result);
    }
}

export default EdiOperator;